import { Button, Typography } from '@mui/material'
import type { FunctionComponent } from 'react'
import * as React from 'react'
import { useNavigate } from 'react-router-dom'
import { FullHeightCard } from '~pages/open-pages/contact/contact'
import { PageRoute } from '../../../../routes/routes-behind-login/page-route'

type ErrorDisplayProps = {
  heading?: string
  isPageError?: boolean
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  text?: string
}

const ErrorDisplay: FunctionComponent<ErrorDisplayProps> = ({
  heading,
  text,
  isPageError,
  onClick,
}) => {
  const navigate = useNavigate()

  return (
    <FullHeightCard disableFullHeight={!isPageError}>
      {heading && (
        <Typography
          sx={{ py: 4, px: 2 }}
          variant={isPageError ? 'h1' : 'h4'}
          component="h1"
        >
          {heading}
        </Typography>
      )}

      {text && (
        <Typography
          sx={{ py: 4, px: 2 }}
          variant={isPageError ? 'h2' : 'paragraph1'}
          component="p"
        >
          {text}
        </Typography>
      )}

      {isPageError && (
        <Button
          variant="contained"
          onClick={(e) => {
            if (onClick) {
              onClick?.(e)
            } else {
              navigate(PageRoute.LANDING)
            }
          }}
        >
          Go to front page
        </Button>
      )}
    </FullHeightCard>
  )
}

export default ErrorDisplay
